import { combineReducers } from "redux";
import user_admin from "../features/admin/masters/user_admin/Slice";

const manage_admin = combineReducers({
  user_admin: user_admin,
});

export default manage_admin;
